import { render, staticRenderFns } from "./win3.vue?vue&type=template&id=68ec0230&scoped=true&"
import script from "./win3.vue?vue&type=script&lang=js&"
export * from "./win3.vue?vue&type=script&lang=js&"
import style0 from "./win3.vue?vue&type=style&index=0&id=68ec0230&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ec0230",
  null
  
)

export default component.exports